module.exports = __webpack_public_path__ + "static/sock-on-feet-4a4a5de6e7aab3da22ea8ff68b51d40e.jpg";